<app-page-title *ngIf="!loading" [heading]="heading" [subheading]="subheading" [icon]="icon"
    [menuConfiguration]="headerMenuConfiguration">
</app-page-title>
<div class="card" *ngIf="!loading">
    <mat-tab-group [(selectedIndex)]="selectedTabIndex">
        <mat-tab label="General details">
            <div class="card-body row" style="width:100%; margin-left:0px">
                <audience-info-block [audience]="audience" style="width: 100%;"></audience-info-block>
            </div>
        </mat-tab>
        <mat-tab label="Transfers">
            <div class="card-body row" style="width:100%; margin-left:0px">
                <transfers-block [transfers]="audience.transfers" [audience]="audience" *ngIf="selectedTabIndex == 1"
                    (onTransferAdded)="loadAudience()" (onTransferChanged)="loadAudience()" style="width: 100%;"></transfers-block>
            </div>
        </mat-tab>
        <mat-tab label="Look-alikes" *ngIf="audience.lookAlikeParametersCalculated">
            <div class="card-body row" style="width:100%; margin-left:0px">
                <audience-lookalikes-block [audience]="audience" style="width: 100%;" (onLookAlikeCreated)="loadAudience()"></audience-lookalikes-block>
            </div>
        </mat-tab>
        <mat-tab label="Comments">
            <div class="card-body row" style="width:100%; margin-left:0px">
                <audience-comments-block style="width: 100%;" [audience]="audience" (onCommentAdded)="loadAudience()"></audience-comments-block>
            </div>
        </mat-tab>
        <mat-tab label="Tags">
            <div class="card-body row" style="width:100%; margin-left:0px">
                <audience-tags-block style="width: 100%;" [audience]="audience"></audience-tags-block>
            </div>
        </mat-tab>
    </mat-tab-group>
</div>